// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".prompt-container[data-v-91ea7eea] {\n  width: 100%;\n  max-width: 768px;\n  margin: 6px auto 0;\n  -webkit-box-shadow: 0px -12px 12px white;\n          box-shadow: 0px -12px 12px white;\n  z-index: 1;\n}\n.prompt-alert .v-alert[data-v-91ea7eea] {\n  margin-bottom: -4px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
